export default "__VITE_ASSET__AUOWLGFs__"